export default class ValidationMessages {
    static unlimitedFieldValidationMessage = 'Please enter integer number or "Unlimited"';

    static requiredInput(inputName: string) {
        return `${inputName} is required`;
    }
}
